/* Northwoofs home: hero slideshow, slider arrows, tile swatches (ported from the design file). */
(function () {
  function initHero(hero) {
    if (hero.dataset.ready) return; hero.dataset.ready = '1';
    var slides = [].slice.call(hero.querySelectorAll('.slide')), dotsW = hero.parentNode.querySelector('.hero-pager'), bar = hero.querySelector('.hero-bar');
    var cur = 0, count = slides.length, timer = null, DUR = parseInt(hero.dataset.dur, 10) || 6000, paused = false;
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (count < 2) { hero.classList.add('single'); return; }
    // indicator: one line along the photo's bottom edge fills over each slide (dots under the photo are optional: add .hero-pager after the section)
    function mark() { if (!dotsW) return; [].forEach.call(dotsW.children, function (d, i) { d.classList.toggle('on', i === cur); d.setAttribute('aria-current', String(i === cur)); }); }
    // hovering pauses: the line stops where it is and carries on from there afterwards
    var left = DUR;
    var ring = hero.querySelector('.hero-ring'), ringFg = ring && ring.querySelector('.fg'), ringN = ring && ring.querySelector('span'), RC = 2 * Math.PI * 17;
    if (ring) { ringFg.style.strokeDasharray = RC; ring.addEventListener('click', function () { go(cur + 1); }); }
    var fnum = hero.querySelector('.hero-fnum .f'), fpill = hero.querySelector('.hero-fpill u');
    [hero.querySelector('.hero-fnum'), hero.querySelector('.hero-fpill')].forEach(function (b) { if (b) b.addEventListener('click', function () { go(cur + 1); }); });
    function runT(el, prop, from, to, ms) { if (!el) return; el.style.transition = 'none'; el.style[prop] = reduce ? to : from; void el.getBoundingClientRect(); if (reduce) return; el.style.transition = prop.replace(/[A-Z]/g, function (c) { return '-' + c.toLowerCase(); }) + ' ' + ms + 'ms linear'; el.style[prop] = to; }
    function runRing(ms) {
      var done = 1 - ms / DUR;
      runT(fnum, 'clipPath', 'inset(' + ((1 - done) * 100).toFixed(1) + '% 0 0 0)', 'inset(0% 0 0 0)', ms);
      runT(fpill, 'width', (done * 100).toFixed(1) + '%', '100%', ms);
      if (!ringFg) return; ringFg.style.transition = 'none';
      if (reduce) { ringFg.style.strokeDashoffset = '0'; return; }
      ringFg.style.strokeDashoffset = String(RC * ms / DUR); void ringFg.getBoundingClientRect();
      ringFg.style.transition = 'stroke-dashoffset ' + ms + 'ms linear'; ringFg.style.strokeDashoffset = '0';
    }
    function runBar(ms) {
      runRing(ms);
      if (!bar) return; bar.style.transition = 'none';
      if (reduce) { bar.style.width = '0'; return; }
      bar.style.width = ((1 - ms / DUR) * 100) + '%'; void bar.offsetWidth;
      bar.style.transition = 'width ' + ms + 'ms linear'; bar.style.width = '100%';
    }
    function freeze() { if (!bar) return; var w = bar.getBoundingClientRect().width / hero.getBoundingClientRect().width; bar.style.transition = 'none'; bar.style.width = (w * 100) + '%'; left = Math.max(0, DUR * (1 - w)); }
    function restart(ms) { clearTimeout(timer); ms = ms == null ? DUR : ms; if (paused) { freeze(); return; } runBar(ms); if (!reduce) timer = setTimeout(function () { go(cur + 1); }, ms); }
    var hgo = [].slice.call(hero.querySelectorAll('[data-hgo]'));
    hgo.forEach(function (b) { b.addEventListener('click', function () { go(+b.dataset.hgo); }); });
    function go(i) { cur = (i + count) % count; slides.forEach(function (sl, k) { sl.classList.toggle('on', k === cur); sl.setAttribute('aria-hidden', String(k !== cur)); }); mark(); hgo.forEach(function (b) { b.classList.toggle('on', +b.dataset.hgo === cur); }); if (ringN) ringN.textContent = cur + 1; hero.querySelectorAll('[data-hn]').forEach(function (e) { e.textContent = cur + 1; }); var cn = hero.querySelector('.hero-count span'); if (cn) cn.textContent = cur + 1; left = DUR; if (bar) { bar.style.transition = 'none'; bar.style.width = '0'; } restart(); }
    if (dotsW) { dotsW.innerHTML = '';
    for (var i = 0; i < count; i++) {
      var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', window.NWT.fmt(window.NWT.common.slide, { number: i + 1 }));
      (function (k) { b.addEventListener('click', function () { go(k); }); })(i); dotsW.appendChild(b);
    } }
    // no pause on hover: the slides keep rotating while the mouse is over the hero
    hero.querySelectorAll('[data-hdir]').forEach(function (b) { b.addEventListener('click', function () { go(cur + (+b.dataset.hdir)); }); });
    var sx = null;
    hero.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1)); sx = null; });
    hero.addEventListener('nw:hero-restart', function () { go(cur); });
    go(0);
  }
  // mobile hero trial switch: only on unpublished (preview/dev) themes; choice remembered in this browser, or ?hm=C
  function initHeroTest(panel) {
    if (panel.dataset.ready) return; panel.dataset.ready = '1';
    var role = window.Shopify && Shopify.theme && Shopify.theme.role;
    if (role === 'main') return;
    var hero = panel.parentNode.querySelector('.hero'); if (!hero) return;
    var KEYS = ['H', 'HB', 'C1', 'C2', 'C3', 'B1', 'B2', 'B3', 'B4', 'B5', 'B6', 'B7', 'B8', 'B9'];
    function set(k) {
      hero.className = hero.className.replace(/\bhero--(m[A-Z]|b\d|hb|nc|k\d)\b/g, ' ').replace(/\s+/g, ' ').trim();
      if (k === 'H') hero.classList.add('hero--mH');
      else if (k === 'HB') hero.classList.add('hero--mH', 'hero--hb');
      else if (/^C\d$/.test(k)) hero.classList.add('hero--mB', 'hero--b9', 'hero--nc', 'hero--k' + k.charAt(1));
      else if (/^B\d$/.test(k)) hero.classList.add('hero--mB', 'hero--b' + k.charAt(1));
      panel.querySelectorAll('[data-hm]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.hm === (k || ''))); });
      try { localStorage.setItem('nwHeroM', k || ''); } catch (e) {}
      requestAnimationFrame(function () { hero.dispatchEvent(new Event('nw:hero-restart')); });
    }
    var start = hero.classList.contains('hero--k1') ? 'C1' : hero.classList.contains('hero--hb') ? 'HB' : hero.classList.contains('hero--mH') ? 'H' : hero.classList.contains('hero--b9') ? 'B9' : '';
    try { var sv = localStorage.getItem('nwHeroM'); if (sv !== null) start = sv; } catch (e) {}
    var q = (new URLSearchParams(location.search).get('hm') || '').toUpperCase(); if (KEYS.indexOf(q) > -1) start = q;
    if (start === 'B') start = 'B1';
    set(KEYS.indexOf(start) > -1 ? start : '');
    panel.addEventListener('click', function (e) {
      var t = e.target.closest('button'); if (!t) return;
      if ('hm' in t.dataset) set(t.dataset.hm);
      else if ('htClose' in t.dataset) panel.hidden = true;
    });
    panel.hidden = false;
  }
  // phone mosaic (.hmz): the big tile and the two small ones step on together; a small tile always shows a story that is not the big one
  function initMosaic(m) {
    if (m.dataset.ready) return; m.dataset.ready = '1';
    var hero = m.closest('.hero'), tiles = [].slice.call(m.querySelectorAll('.hmz-t'));
    var n = tiles.length ? tiles[0].querySelectorAll('.hmz-f').length : 0; if (n < 2) return;
    var DUR = parseInt(hero.dataset.dur, 10) || 6000, cur = 0, timer = null;
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    function show(i) {
      cur = (i + n) % n;
      tiles.forEach(function (t) { [].forEach.call(t.querySelectorAll('.hmz-f'), function (f, k) { var on = k === cur; f.classList.toggle('on', on); if (on) { f.removeAttribute('tabindex'); f.removeAttribute('aria-hidden'); } else { f.setAttribute('tabindex', '-1'); f.setAttribute('aria-hidden', 'true'); } }); });
    }
    function live() { return hero.classList.contains('hero--mH') && getComputedStyle(m).display !== 'none' && !document.hidden; }
    function tick() { clearTimeout(timer); timer = setTimeout(function () { if (live()) show(cur + 1); tick(); }, DUR); }
    tick();
  }
  function init(root) {
    (root || document).querySelectorAll('.nwh .hero').forEach(initHero);
    (root || document).querySelectorAll('.nwh [data-hero-test]').forEach(initHeroTest);
    (root || document).querySelectorAll('.nwh [data-hmz]').forEach(initMosaic);
  }
  // slider arrows: <button data-scroll="id" data-dir="1">
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.nwh [data-scroll]'); if (!b) return;
    var t = document.getElementById(b.dataset.scroll); if (!t) return;
    t.scrollBy({ left: t.clientWidth * 0.8 * (+b.dataset.dir), behavior: 'smooth' });
  });
  // swatches: pick a colour without following the tile link
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.nwh .sw'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    b.parentElement.querySelectorAll('.sw').forEach(function (x) { x.classList.toggle('on', x === b); });
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* Touch screens: show a tile's second photo while the finger is on it, also while it swipes the row (the rows are
   swiped by the script below). A quick tap changes nothing, so iPhones open the product on the first tap (Safari
   skips the click when something on the page changes during a tap). */
(function () {
  let tile = null, timer = 0, later = 0, last = null, moved = false;
  const show = () => { if (tile) tile.classList.add('peek'); };
  const hide = t => { if (t) t.classList.remove('peek'); };
  document.addEventListener('touchstart', e => {
    clearTimeout(timer); clearTimeout(later); hide(tile); hide(last); moved = false;
    tile = e.target.closest && !e.target.closest('.sws') && e.target.closest('.nwh .tile');  // not when the finger is on the colour dots
    if (!tile || !tile.querySelector('img.alt')) { tile = null; return; }
    timer = setTimeout(show, 180);
  }, { passive: true });
  document.addEventListener('touchmove', () => { if (tile && !moved) { moved = true; clearTimeout(timer); show(); } }, { passive: true });
  const end = () => {
    clearTimeout(timer); const t = tile; tile = null; if (!t) return;
    if (!moved) { last = t; later = setTimeout(() => hide(t), 400); } else hide(t);
  };
  document.addEventListener('touchend', end, { passive: true });
  document.addEventListener('touchcancel', end, { passive: true });
  window.addEventListener('pagehide', () => { hide(tile); tile = null; });
})();

/* Touch screens: the tile rows (.track) are swiped by this script, not by the browser, so that a finger landing on a
   row that is still gliding is seen (iPhone Safari sends no touch events for that) and every swipe shows the second
   photo. The row follows the finger by sliding its tiles (--nw-dx, drawn once per
   frame), and after the finger lets go it glides on and slows down the way iOS scrolling does (exponential decay),
   aimed so it comes to rest exactly on a tile. Only then is the row's real scroll position set and the slide cleared.
   A finger that lands on a moving row catches it where it is. Up and down stays the browser's own page scroll. */
(function () {
  if (!window.matchMedia('(hover: none) and (pointer: coarse)').matches) return;
  const TAU = 325;        // ms: how quickly a glide slows down (a flick carries its speed x this far)
  const EDGE = 0.35;      // past either end the row follows the finger at this rate
  const FRAME = 1000 / 60;
  let st = null, axis = '', x0 = 0, y0 = 0, p0 = 0, pts = [], frame = 0, anim = 0;
  const stopsOf = r => {
    const pad = parseFloat(getComputedStyle(r).scrollPaddingLeft) || 0, left = r.getBoundingClientRect().left - r.scrollLeft, max = r.scrollWidth - r.clientWidth;
    return [...r.children].map(c => Math.round(Math.min(max, Math.max(0, c.getBoundingClientRect().left - left - pad))));
  };
  const shown = s => s.pos < 0 ? s.pos * EDGE : s.pos > s.max ? s.max + (s.pos - s.max) * EDGE : s.pos;
  const put = (s, p) => s.r.style.setProperty('--nw-dx', (s.base - p) + 'px');
  const draw = () => { frame = 0; if (st) put(st, shown(st)); };
  const queue = () => { if (!frame) frame = requestAnimationFrame(draw); };
  const commit = s => {
    cancelAnimationFrame(anim); anim = 0;
    s.r.style.removeProperty('--nw-dx'); s.r.scrollLeft = Math.round(s.target ?? shown(s));
    if (st === s) st = null;
  };
  const nearest = (s, p) => s.stops.reduce((a, b) => Math.abs(b - p) < Math.abs(a - p) ? b : a, 0);
  /* from where the row is shown now, glide to s.target: pos(t) = target - d0 * e^(-t / TAU). The first frame counts
     as one frame already gone, so the row never stands still between the finger and the glide. */
  const glide = s => {
    const d0 = s.target - shown(s); let t0 = 0;
    const step = now => {
      if (!t0) t0 = now - FRAME;
      const d = d0 * Math.exp(-(now - t0) / TAU);
      s.pos = s.target - d; put(s, s.pos);
      if (Math.abs(d) < 0.5) { commit(s); return; }
      anim = requestAnimationFrame(step);
    };
    cancelAnimationFrame(frame); frame = 0;
    cancelAnimationFrame(anim); anim = requestAnimationFrame(step);
  };
  const warm = r => {   // every photo in the row decoded before the first swipe shows it
    if (r.dataset.nwWarm) return; r.dataset.nwWarm = '1';
    r.querySelectorAll('img').forEach(i => { i.loading = 'eager'; if (i.decode) i.decode().catch(() => {}); });
  };
  document.addEventListener('touchstart', e => {
    const r = e.touches.length === 1 && e.target.closest && e.target.closest('.nwh .track');
    axis = ''; pts = [];
    if (st && st.r !== r) commit(st);          // a row still gliding elsewhere jumps to its tile
    if (!r) return;
    warm(r);
    if (st && anim) { cancelAnimationFrame(anim); anim = 0; st.target = null; st.caught = true; }   // caught while moving
    else st = { r, base: r.scrollLeft, pos: r.scrollLeft, max: r.scrollWidth - r.clientWidth, stops: stopsOf(r), target: null, caught: false };
    x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; p0 = st.pos;
  }, { passive: true });
  const rest = () => { st.pos = shown(st); st.target = nearest(st, st.pos); glide(st); };
  document.addEventListener('touchmove', e => {
    if (!st || axis === 'y') return;
    const t = e.touches[0];
    if (!axis) {
      if (Math.abs(t.clientX - x0) < 8 && Math.abs(t.clientY - y0) < 8) return;
      axis = Math.abs(t.clientX - x0) > Math.abs(t.clientY - y0) ? 'x' : 'y';
      if (axis === 'y') { if (st.caught) rest(); else st = null; return; }
      x0 = t.clientX; p0 = st.pos;
    }
    if (e.cancelable) e.preventDefault();
    st.pos = p0 - (t.clientX - x0);
    pts.push([e.timeStamp, t.clientX]);
    while (pts.length > 2 && e.timeStamp - pts[0][0] > 100) pts.shift();
    queue();
  }, { passive: false });
  const end = () => {
    if (!st || axis === 'y') return;
    if (axis === '') { if (st.caught) rest(); else st = null; return; }   // a tap
    const a = pts[0], b = pts[pts.length - 1];
    const v = a && b && b[0] > a[0] ? -(b[1] - a[1]) / (b[0] - a[0]) : 0;   // the row's speed in px per ms, + = towards the end
    st.pos = shown(st);
    let to = nearest(st, st.pos + v * TAU);                                   // where the glide would come to rest
    if (v > 0.2 && to <= st.pos + 2) to = st.stops.find(p => p > st.pos + 2) ?? st.max;              // a flick moves at least one tile
    if (v < -0.2 && to >= st.pos - 2) to = [...st.stops].reverse().find(p => p < st.pos - 2) ?? 0;
    st.target = Math.min(st.max, Math.max(0, to));
    glide(st);
  };
  document.addEventListener('touchend', end, { passive: true });
  document.addEventListener('touchcancel', end, { passive: true });
})();
